<template>
  <a-card title="报警监测" :bordered="false" class="alarm-monitoring-card">
    <template slot="extra">
      <div class="search-wrapper">
        <div class="search-item">
          <span class="label">查询时间：</span>
          <a-range-picker v-model="queryParams.dateRange" style="width: 240px" size="small" />
        </div>
        <a-button type="primary" class="custom-query-btn" @click="handleQuery">查询</a-button>
      </div>
    </template>

    <div class="chart-container">
      <div ref="alarmChartRef" style="width: 100%; height: 320px;"></div>
    </div>
  </a-card>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'AlarmMonitoring',
  data () {
    return {
      queryParams: {
        dateRange: []
      },
      chart: null
    }
  },
  mounted () {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    handleQuery () {
      this.initChart()
    },
    handleResize () {
      this.chart && this.chart.resize()
    },
    initChart () {
      const chartDom = this.$refs.alarmChartRef
      if (!this.chart) {
        this.chart = echarts.init(chartDom)
      }

      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderWidth: 0,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          padding: [12, 16],
          formatter: function (params) {
            let html = `<div style="color: #999; margin-bottom: 8px;">2025.11.28 10:00</div>`
            params.forEach(item => {
              html += `
                <div style="display: flex; align-items: center; justify-content: space-between; min-width: 120px; margin-bottom: 4px;">
                  <div style="display: flex; align-items: center;">
                    <span style="display: inline-block; width: 8px; height: 8px; border-radius: 50%; background: ${item.color}; margin-right: 12px;"></span>
                    <span style="color: #666;">${item.seriesName}</span>
                  </div>
                  <span style="font-weight: bold; color: ${item.color}; font-size: 16px;">${item.value}</span>
                </div>
              `
            })
            return html
          }
        },
        legend: {
          show: false // 我们使用 Tooltip 展示详情
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00', '24:00'],
          axisLine: {
            lineStyle: {
              color: '#eee'
            }
          },
          axisLabel: {
            color: '#999'
          }
        },
        yAxis: {
          type: 'value',
          name: '次数',
          min: 0,
          max: 20,
          interval: 2,
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: '#f5f5f5'
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#999'
          }
        },
        series: [
          {
            name: '设备故障',
            type: 'line',
            smooth: false,
            data: [11.5, 14, 11.5, 13, 11.5, 16, 17, 13, 11.5, 10, 11, 9, 8.5],
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: { color: '#ffa940' },
            lineStyle: { width: 2 }
          },
          {
            name: '数据异常',
            type: 'line',
            smooth: false,
            data: [9, 11.5, 9, 10.5, 9, 13.5, 14.5, 11, 8.5, 10.5, 8.5, 7, 10],
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: { color: '#ff4d4f' },
            lineStyle: { width: 2 }
          },
          {
            name: '数据中断',
            type: 'line',
            smooth: false,
            data: [14, 15.5, 12.5, 15.5, 14, 15, 18, 15, 14, 12.5, 13.5, 12, 11.5],
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: { color: '#8c8c8c' },
            lineStyle: { width: 2 }
          }
        ]
      }

      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="less" scoped>
.alarm-monitoring-card {
  .search-wrapper {
    display: flex;
    align-items: center;

    .search-item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        white-space: nowrap;
        color: #666;
        margin-right: 8px;
      }
    }

    .custom-query-btn {
      border-radius: 0;
      padding: 0 20px;
      height: 32px;
      background-color: #1890ff;
      border-color: #1890ff;
      font-size: 14px;
    }
  }

  .chart-container {
    padding-top: 10px;
  }
}
</style>
